var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('el-cascader',{attrs:{"size":"medium","options":[]},model:{value:(_vm.value),callback:function ($$v) {_vm.value=$$v},expression:"value"}}),_c('el-input',{staticStyle:{"margin-top":"10px"},attrs:{"size":"medium","readonly":"","placeholder":"请输入详细地址","show-word-limit":"","rows":2,"type":"textarea"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }